import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const PlusCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-8.75-4.583a1.25 1.25 0 0 0-2.5 0V8.75H5.417a1.25 1.25 0 1 0 0 2.5H8.75v3.333a1.25 1.25 0 0 0 2.5 0V11.25h3.333a1.25 1.25 0 0 0 0-2.5H11.25z" }), _jsx("path", { d: "M10 4.167c.69 0 1.25.56 1.25 1.25V8.75h3.333a1.25 1.25 0 1 1 0 2.5H11.25v3.333a1.25 1.25 0 0 1-2.5 0V11.25H5.417a1.25 1.25 0 0 1 0-2.5H8.75V5.417c0-.69.56-1.25 1.25-1.25", fill: innerFillValue })] }));
});
PlusCircled.displayName = 'PlusCircled';
PlusCircled.__iconComponentType = 'contrast';
export default PlusCircled;
//# sourceMappingURL=PlusCircled.js.map